import { useNavigate } from "react-router-dom";
import { Box, Paper } from "@mui/material";
import { ConnectBrokerPanel } from "@/components/ConnectBrokerPanel";

/**
 * "+ Add new account" page — routed from the account-selector
 * dropdown at AccountsPageV2. Hosts the shared `ConnectBrokerPanel`
 * (the same broker picker + WhiteHat Paper create flow used inside the
 * Marketplace Buy flow). On success it returns to /accounts.
 */
export function AddAccountPage() {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 560, mx: "auto", px: 2, py: 3 }}>
      <Paper variant="outlined" sx={{ borderRadius: 3, overflow: "hidden" }}>
        <ConnectBrokerPanel
          onCreated={() => navigate("/accounts")}
          onCancel={() => navigate("/accounts")}
        />
      </Paper>
    </Box>
  );
}
